var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearchNoResults(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 320,
    height: 117,
    viewBox: "0 0 320 117",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57.2539 18.1211V112.065H144.54L186.038 65.8326L201.128 18.1211H57.2539Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M146.686 43.9376H24.6328V34.6172H146.686C149.275 34.6172 151.346 36.6884 151.346 39.2774C151.346 41.8664 149.275 43.9376 146.686 43.9376Z",
    fill: "#6929C4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M122.053 69.754H0V60.4336H122.053C124.642 60.4336 126.713 62.5048 126.713 65.0938C126.713 67.6828 124.568 69.754 122.053 69.754Z",
    fill: "#6929C4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M144.539 116.504C142.098 116.504 139.879 115.542 138.178 113.841C134.701 110.364 134.701 104.594 138.178 101.117L169.098 70.1974C165.621 64.4277 163.772 57.8442 163.772 50.9649C163.772 40.9788 167.618 31.5844 174.72 24.5571C181.747 17.5299 191.141 13.6094 201.127 13.6094C211.114 13.6094 220.508 17.4559 227.535 24.5571C234.562 31.5844 238.483 40.9788 238.483 50.9649C238.483 60.951 234.636 70.3454 227.535 77.3727C220.508 84.3999 211.114 88.3204 201.127 88.3204C194.248 88.3204 187.665 86.4711 181.895 82.9945L150.901 113.915C149.2 115.616 146.98 116.504 144.539 116.504Z",
    fill: "#6929C4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M224.355 27.7384C211.558 14.9414 190.624 14.9414 177.827 27.7384C171.613 33.952 168.21 42.2368 168.21 50.9654C168.21 58.2146 170.577 65.0939 174.868 70.7897L141.359 104.299C139.584 106.074 139.584 108.959 141.359 110.734C143.134 112.51 146.019 112.51 147.794 110.734L181.303 77.2252C186.999 81.5156 193.878 83.8826 201.128 83.8826C209.93 83.8826 218.141 80.48 224.355 74.2664C230.568 68.0528 233.971 59.768 233.971 51.0394C234.045 42.1628 230.568 33.952 224.355 27.7384Z",
    fill: "#52A9FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M220.879 70.7154C215.628 75.9674 208.6 78.9262 201.129 78.9262C193.658 78.9262 186.631 76.0414 181.379 70.7154C176.127 65.4635 173.168 58.4362 173.168 50.9651C173.168 43.494 176.053 36.4667 181.379 31.2147C186.631 25.9628 193.658 23.0039 201.129 23.0039C208.6 23.0039 215.628 25.8888 220.879 31.2147C226.131 36.4667 229.09 43.494 229.09 50.9651C229.09 58.4362 226.131 65.4635 220.879 70.7154Z",
    fill: "#F3F3F3"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M201.13 69.3846C211.302 69.3846 219.549 61.1382 219.549 50.9657C219.549 40.7933 211.302 32.5469 201.13 32.5469C190.957 32.5469 182.711 40.7933 182.711 50.9657C182.711 61.1382 190.957 69.3846 201.13 69.3846Z",
    fill: "#07BDBA"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M201.128 59.4704C205.826 59.4704 209.635 55.6619 209.635 50.9637C209.635 46.2656 205.826 42.457 201.128 42.457C196.43 42.457 192.621 46.2656 192.621 50.9637C192.621 55.6619 196.43 59.4704 201.128 59.4704Z",
    fill: "#1A1A1A"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M207.12 49.8541C209.817 49.8541 212.003 47.6683 212.003 44.972C212.003 42.2756 209.817 40.0898 207.12 40.0898C204.424 40.0898 202.238 42.2756 202.238 44.972C202.238 47.6683 204.424 49.8541 207.12 49.8541Z",
    fill: "#F3F3F3"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M315.562 42.0157H247.434C244.993 42.0157 242.996 40.0185 242.996 37.5774V4.43828C242.996 1.99723 244.993 0 247.434 0H315.562C318.003 0 320 1.99723 320 4.43828V37.5774C320 40.0185 318.003 42.0157 315.562 42.0157Z",
    fill: "#07BDBA"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M290.782 14.6466L287.897 11.7617L281.535 18.1233L275.1 11.7617L272.215 14.6466L278.65 21.0081L272.215 27.4436L275.1 30.3285L281.535 23.893L287.897 30.3285L290.782 27.4436L284.42 21.0081L290.782 14.6466Z",
    fill: "#6929C4"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M254.906 53.7038V36.3945H272.216L254.906 53.7038Z",
    fill: "#07BDBA"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 57.2657,
    y1: 65.0944,
    x2: 201.114,
    y2: 65.0944,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6929C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1831,
    stopColor: "#6736CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5215,
    stopColor: "#6158D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9749,
    stopColor: "#578FF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5692F4"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchNoResults);
export default __webpack_public_path__ + "static/media/SearchNoResults.6c5a861c.svg";
export { ForwardRef as ReactComponent };